import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer
      data-testid="footer-section"
      className="relative py-16 md:py-24 bg-white overflow-hidden border-t border-gray-100"
    >
      {/* Watermark */}
      <div className="absolute bottom-0 left-0 right-0 font-oswald uppercase footer-watermark text-primary text-center">
        LOOSE LEAF
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Logo & Info */}
          <div>
            <span className="font-oswald uppercase text-2xl font-bold tracking-tight">
              <span className="text-gray-900">Loose Leaf</span>
              <span className="text-primary"> Media</span>
            </span>
            <p className="font-manrope text-sm text-gray-500 mt-4">
              Dubai-based · Global mindset
            </p>
            <p className="font-manrope text-sm text-gray-700 mt-2">
              Platform-native. System-built. Growth-focused.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-oswald uppercase text-sm font-bold text-gray-900 tracking-widest">
              Quick Links
            </h4>
            <nav className="mt-4 flex flex-col gap-3">
              <Link
                to="/"
                className="font-manrope text-sm text-gray-500 hover:text-primary transition-colors"
              >
                Home
              </Link>
              <Link
                to="/services"
                className="font-manrope text-sm text-gray-500 hover:text-primary transition-colors"
              >
                Services
              </Link>
              <Link
                to="/about"
                className="font-manrope text-sm text-gray-500 hover:text-primary transition-colors"
              >
                About
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-oswald uppercase text-sm font-bold text-gray-900 tracking-widest">
              Get in Touch
            </h4>
            <div className="mt-4">
              <a
                href="https://calendly.com/atabdullah-mah/30min"
                target="_blank"
                rel="noopener noreferrer"
                className="font-manrope text-sm text-primary hover:text-primary/80 transition-colors"
                data-testid="footer-book-call"
              >
                Book a Call →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-100 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-manrope text-sm text-gray-500">
            Loose Leaf Media · Dubai-based · Global mindset
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              className="font-manrope text-sm text-gray-500 hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-and-conditions"
              className="font-manrope text-sm text-gray-500 hover:text-primary transition-colors"
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
